module.exports = __webpack_public_path__ + "static/media/how-it-works-a-few-steps-03.4bf5f079.jpg";